var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRekreativtnaturomraade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.59 15.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      fill: #071f39;\n      }\n\n      .cls-1, .cls-2 {\n      stroke-width: 0px;\n      }\n\n      .cls-2 {\n      fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cirkel"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 0,
    width: 15.59,
    height: 15.59,
    rx: 7.8,
    ry: 7.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.56,8.74s-1.62-2.81-1.64-2.84c-.02-.03,0-.09.05-.09h.64c.16,0,.26-.17.18-.31l-1.89-3.28c-.08-.14-.28-.14-.36,0l-1.89,3.28c-.08.14.02.31.18.31,0,0,.59,0,.64,0,.04,0,.06.06.05.08-.01.03-1.64,2.85-1.64,2.85-.08.14.02.31.18.31h2.07c.11,0,.2.09.2.2v2.17c0,.22.18.39.39.39s.39-.18.39-.39v-2.16c0-.11.09-.21.21-.21h2.07c.16,0,.26-.17.18-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.55,7.46c-.34-.16-.68-.33-1.03-.49-.21-.51-.43-1.01-.64-1.52-.02-.05-.05-.13-.12-.2-.03-.03-.1-.1-.21-.14-.15-.06-.28-.04-.34-.02-.12.03-.21.09-.25.12l-1.28.65c-.07.04-.13.07-.19.1-.03.01-.06.03-.09.06-.02.02-.03.05-.05.08-.03.07-.05.11-.06.15-.02.07-.14.36-.49,1.17-.01.02-.03.06-.04.11,0,.03-.02.08,0,.15.02.1.09.16.11.18.03.02.1.07.2.08.1,0,.18-.05.2-.06.07-.05.1-.1.12-.13.17-.42.34-.84.52-1.25.25-.13.16-.06.39-.12-.24,1.36-.36,1.89-.66,3.26-.44.56-.74,1.02-1.18,1.58-.02.03-.06.1-.07.19,0,.02,0,.12.05.23.06.1.15.15.17.16.13.06.25.03.29.02.12-.04.19-.12.21-.15.44-.57.84-.89,1.28-1.45l.6-.65c.37.23.24.14.65.37.05.55.19.89.24,1.44,0,.04,0,.1.02.16.01.04.04.12.12.2.02.02.13.12.29.1.15-.01.23-.11.26-.13.03-.03.1-.1.11-.22,0-.03,0-.06,0-.08l-.17-1.85s0-.07-.02-.11c-.02-.06-.05-.1-.07-.13-.36-.44-.52-.65-.88-1.09.06-.44.13-.72.2-1.17.09.12.11.15.12.15.02.02.04.06.09.12,0,.03.03.07.06.12.04.05.09.08.11.09.38.18.76.35,1.14.53.03,0,.12.03.22,0,.09-.03.14-.09.15-.1.01-.02.05-.07.07-.16.01-.1-.02-.17-.03-.19-.04-.07-.09-.11-.12-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.76,4.88c.42,0,.76-.34.76-.76s-.34-.76-.76-.76-.76.34-.76.76.34.76.76.76Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRekreativtnaturomraade);
export default __webpack_public_path__ + "static/media/REKREATIVTNATUROMRAADE.941f0bd9801aaa9190495e4648ba5264.svg";
export { ForwardRef as ReactComponent };